module.exports = __webpack_public_path__ + "static/img/bc-cnhmzl.96c86ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/bc-cnhmzl.png
// module id = LwF5
// module chunks = 0